import { LanguageSwitcher } from "components/LanguageSwitcher";
import { Logo } from "components/Logo";
import { Container } from "react-grid-system";
import MobileMenu from "./MobileMenu";
import { scrollToSection } from "utils/scrollToSection";
import { useTranslation } from "react-i18next";
import { navigation } from "config/navigation";

export const Header = () => {
  const { t, i18n } = useTranslation();
  const langPrefix = i18n.language === 'en' ? '' : `/${i18n.language}`;

  return (
    <header className="pt-4 lg:pt-10 bg-heroBackground">
      <Container>
        <div className="max-w-[1200px] mx-auto flex items-center justify-between">
          <Logo />
          <nav className="hidden lg:flex items-center space-x-10 text-textPrimary">
            {navigation.items.map((item) =>
              item.isPage ? (
                <a
                  key={item.id}
                  href={`${langPrefix}/${item.anchor}/`}
                  className={
                    item.id === "creators"
                      ? "text-lg font-bold text-[#D6488E] hover:opacity-80"
                      : "text-lg hover:text-hoverNavigation"
                  }
                >
                  {t(item.translationKey)}
                </a>
              ) : (
                <button
                  key={item.id}
                  className="text-lg hover:text-hoverNavigation"
                  onClick={() => {
                    scrollToSection(item.anchor);
                  }}
                >
                  {t(item.translationKey)}
                </button>
              )
            )}
            <LanguageSwitcher />
          </nav>
          <MobileMenu />
        </div>
      </Container>
    </header>
  );
};
